import { Component, Vue } from "nuxt-property-decorator";
import {
  DEFAULT_PELLETS_CHART_MONTHS,
  PelletsChartMonths,
} from "~/utils/pelletsChart";

@Component
export default class PelletsChartRangeMixin extends Vue {
  monthsQuantity: PelletsChartMonths = DEFAULT_PELLETS_CHART_MONTHS;

  async dispatchChartFetch(_months: PelletsChartMonths): Promise<void> {
    throw new Error(
      "PelletsChartRangeMixin: dispatchChartFetch must be implemented",
    );
  }

  async onChartRangeChange(months: PelletsChartMonths): Promise<void> {
    this.monthsQuantity = months;
    await this.dispatchChartFetch(months);
  }
}
